import { useTranslation } from 'react-i18next';
import Loader from '../Icons/Loader';
import Button from '../Button';
import { commonTradPrefix } from '@/legacy/i18n';

const LoadingButton = () => {
	const { t } = useTranslation();
	return (
		<Button
			text={t(`${commonTradPrefix}.loading`)}
			iconLeft={
				<Loader
					color='#fff'
					width={24}
					height={24}
				/>
			}
			disabled
			style='highlighted'
		/>
	);
};

export default LoadingButton;
